import { useState, useEffect } from 'react'

// Module-level cache so the canvas runs exactly once across all component instances
let _cached = null
let _promise = null

export function getTransparentLogoSrc() {
  if (_cached) return Promise.resolve(_cached)
  if (_promise) return _promise

  _promise = new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas')
        canvas.width = img.naturalWidth
        canvas.height = img.naturalHeight
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
        const d = imageData.data
        for (let i = 0; i < d.length; i += 4) {
          const avg = (d[i] + d[i + 1] + d[i + 2]) / 3
          if (avg > 230) {
            d[i + 3] = 0
          } else if (avg > 190) {
            d[i + 3] = Math.round(255 * (1 - (avg - 190) / 40))
          }
        }
        ctx.putImageData(imageData, 0, 0)
        _cached = canvas.toDataURL('image/png')
        resolve(_cached)
      } catch {
        // Canvas blocked (cross-origin / security) — fall back to original
        resolve('/galary/logo2.jpg')
      }
    }
    img.onerror = () => resolve('/galary/logo2.jpg')
    img.src = '/galary/logo2.jpg'
  })

  return _promise
}

/**
 * Renders logo2.jpg with its white background stripped via Canvas API.
 * Props:
 *   size      – px dimension (width & height), default 40
 *   className – extra Tailwind / CSS classes on the <img>
 *   style     – inline style object merged onto the <img>
 *   glow      – boolean: adds a golden drop-shadow filter
 */
export default function TransparentLogo({ size = 40, className = '', style = {}, glow = false }) {
  const [src, setSrc] = useState('/galary/logo2.jpg')

  useEffect(() => {
    getTransparentLogoSrc().then(setSrc)
  }, [])

  return (
    <img
      src={src}
      alt="Temple Logo"
      width={size}
      height={size}
      className={className}
      style={{
        objectFit: 'contain',
        filter: glow
          ? 'drop-shadow(0 0 8px rgba(255,183,77,0.85)) drop-shadow(0 2px 12px rgba(255,107,0,0.5))'
          : 'drop-shadow(0 0 5px rgba(255,183,77,0.6))',
        ...style,
      }}
    />
  )
}
